export default __webpack_public_path__ + "static/image-article-preview-1c5ded715ac10c3af1d5ee51344294aa.png";